import { generateClient } from 'aws-amplify/api'
import {
  getUniqueCallerStats as getUniqueCallerStatsQuery,
} from '@/graphql/queries'
import {
  bulkAddCallers as bulkAddCallersMutation,
} from '@/graphql/mutations'
import { parseAwsJson } from '@/utils/graphql'
import { getApiMessage, isApiSuccess } from '@/mixins/Extras/ApiResponse'

const client = generateClient()

export async function fetchUniqueCallerStats(input = {}) {
  try {
    const { data, errors } = await client.graphql({
      query: getUniqueCallerStatsQuery,
      variables: { input },
    })

    const parsed = parseAwsJson(data?.getUniqueCallerStats)
    if (parsed != null) {
      return parsed
    }

    if (errors?.length) {
      throw new Error(errors[0].message)
    }

    return null
  } catch (error) {
    return {
      status: 'ERROR',
      message: getApiMessage(error, 'Failed to load callers'),
    }
  }
}

/**
 * Bulk-add callers parsed client-side from a CSV/Excel file
 * (see @/utils/callersBulkUpload). Synchronous -- returns added/skipped
 * counts directly, no upload_id/polling (caller lists are small; the
 * heavy async S3-upload pattern used for bulk leads isn't needed here).
 */
export async function bulkAddCallers(org_id, callers = []) {
  try {
    const { data, errors } = await client.graphql({
      query: bulkAddCallersMutation,
      variables: { input: { org_id, callers } },
    })

    if (errors?.length) {
      throw new Error(errors[0].message)
    }

    const parsed = parseAwsJson(data?.bulkAddCallers)
    if (!isApiSuccess(parsed)) {
      return {
        status: 'ERROR',
        message: getApiMessage(parsed, 'Failed to bulk-add callers'),
      }
    }
    return parsed
  } catch (error) {
    return {
      status: 'ERROR',
      message: getApiMessage(error, 'Failed to bulk-add callers'),
    }
  }
}
